import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { post } from "../helper/helper_api";

export default function Career() {

  const [data, setData] = useState(undefined)
  const [job, setJob] = useState(undefined)
  useEffect(() => {
    getData()
    getCarrer()
  },[])

  const getData = () => {
    let body = {
      plant: 'Hyderabad Plant',
    }
    console.log('body', body)
    post('/tender/plant', body)
      .then((res) => {
        // console.log('Gurgaon Plant res', res)
        setData(res?.archiveData)
      }).catch(error => {
        console.log('error', error)
      })
  }

  const getCarrer = () => {
    let body = {
      plant: 'Hyderabad Plant',
    }
    console.log('body', body)
    post('/job/plant', body)
      .then((res) => {
        // console.log('Gurgaon Plant res', res)
        setJob(res?.archiveData)
      }).catch(error => {
        console.log('error', error)
      })
  }
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>HYDERABAD PLANT TENDERS</h2>
                        <div class="clearfix"></div>
                        {
                          data?.length > 0 ? <div class="tender">
                            <ul>
                              {
                                data?.map((item, index) => (
                                  <li class="altcolor">
                                    <a
                                      href={item?.pdf}
                                      target="_blank"
                                    >
                                      <img src="../images/pdf-download-icon.png" />
                                      {item?.title}
                                    </a>
                                  </li>
                                ))
                              }


                            </ul>
                          </div>
                            :
                            <div class="tender">
                              <ul>
                                <li class="altcolor">No tender available</li>
                              </ul>
                            </div>
                        }
                      </div>
                      <div class="inner_content contactpage">
                        <h2>HYDERABAD PLANT CAREER</h2>
                        <div class="clearfix"></div>
                        {
                          job?.length > 0 ? <div class="tender">
                            <ul>
                              {
                                job?.map((item, index) => (
                                  <li class="altcolor">
                                    <a
                                      href={item?.pdf}
                                      target="_blank"
                                    >
                                      <img src="../images/pdf-download-icon.png" />
                                      {item?.title}
                                    </a>
                                  </li>
                                ))
                              }


                            </ul>
                          </div>
                            :
                            <div class="tender">
                              <ul>
                                <li class="altcolor">No tender available</li>
                              </ul>
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
